import { Component, Directive, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { BbTemplate } from '@backbase/foundation-ang/core';
import { CapabilityData } from '@backbase/identity-core-ang';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

@Component({
  selector: 'bb-transaction-signing-interface',
  templateUrl: 'interface.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionSigningInterfaceComponent {
  @Output() failure = new EventEmitter<Error>();
  /* tslint:disable-next-line */
  @Output() success = new EventEmitter<void>();
  @Output() poll = new EventEmitter<object>();
  @Output() post = new EventEmitter<object>();
  /**
   * Whether a signing is pending.
   */
  @Input() isPending = false;
  /**
   * An error received during signing.
   */
  @Input() error: Error | undefined;
  /**
   * Data defining the transaction.
   */
  @Input() transactionData: CapabilityData | undefined;
  /**
   * The type of challenge.
   */
  @Input() challengeType: string | undefined;
  @Input()
  set challengeData(newData: object | undefined) {
    this.previousChallengeData = this.currentChallengeData;
    this.currentChallengeData = { ...this.previousChallengeData, ...newData };
  }

  @Input() enableResendPushNotification!: Observable<boolean>;

  /**
   * The data involved in the challenge.
   */
  get challengeData() {
    if (!this.currentChallengeData) {
      throw new Error('No current challenge data set');
    }
    return this.currentChallengeData;
  }

  /**
   * An error received during authentication.
   */
  @Input() challengeError: Error | undefined;

  readonly hostRef = this;
  readonly modalOptions: NgbModalOptions = {
    keyboard: false,
    backdrop: 'static',
    windowClass: 'bn-transaction-signing-widget__modal',
  };
  previousChallengeData: object | undefined;
  private currentChallengeData: object | undefined;

  isChallengeType(value: string) {
    return this.challengeType === value;
  }
}

@Directive({
  selector: '[bbTransactionSigningInterfaceCustomizable]',
})
export class TransactionSigningInterfaceCustomizableDirective extends BbTemplate<
  TransactionSigningInterfaceComponent,
  undefined
> {}
